import React, { createContext, useState, useEffect } from 'react';
import { auth, db } from './firebase';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isAgeVerified, setIsAgeVerified] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (firebaseUser) => {
            setLoading(true);

            if (firebaseUser) {
                try {
                    const userRef = doc(db, 'users', firebaseUser.uid);
                    const userDoc = await getDoc(userRef);

                    if (!userDoc.exists()) {
                        await setDoc(userRef, {
                            userProfile: {
                                userEmail: firebaseUser.email,
                                username: firebaseUser.email,
                                profileImage: firebaseUser.photoURL || '',
                            },
                            role: 'user',
                            createdAt: serverTimestamp(),
                        });
                    }

                    // Re-fetch doc in case we just created it
                    const latestDoc = await getDoc(userRef);
                    const userData = latestDoc.exists() ? latestDoc.data() : { role: 'user' };
                    setUser(firebaseUser);

                    const isAdminUser = userData?.role === 'admin' || userData?.isAdmin === true;
                    setIsAdmin(isAdminUser);
                    setIsAgeVerified(userData?.isAgeVerified === true);
                } catch (error) {
                    console.error("Error fetching user data:", error);
                    setUser(firebaseUser);
                    setIsAgeVerified(false);
                }
            } else {
                setUser(null);
                setIsAdmin(false);
                setIsAgeVerified(false);
            }

            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    return (
        <AuthContext.Provider value={{ user, isAdmin, isAgeVerified, setIsAgeVerified, loading }}>
            {children}
        </AuthContext.Provider>
    );
};